// Hide unit coefficients only when attached to a variable or factor.
// Numeric substitutions such as a = -1 or (-1)^2 remain explicit in solutions.
export function coefficientLatex(value) {
  return value===1?"":value===-1?"-":String(value);
}
export function quadraticPolynomialLatex(a,b,c) {
  return [[a,"x^2"],[b,"x"],[c,""]].filter(([n])=>n!==0).map(([n,variable],i)=>{
    const magnitude=variable?`${coefficientLatex(Math.abs(n))}${variable}`:String(Math.abs(n));
    return `${n<0?"-":i?"+":""}${magnitude}`;
  }).join("")||"0";
}
export function shiftedXLatex(root) {
  return root===0?"x":`x${root<0?"+":"-"}${Math.abs(root)}`;
}
